import axios from "axios";
import { getToken, getTokenMicro } from "../../config/getToken";
import { env } from "../../env";
import { convertFileToBase64 } from "../../utils/functions";
import { CODES } from "../../consts/codes";

//TODO: Ajustar el metodo UploadSalesForceService por integracion de grupo empresarial (yo lo ajuste creo q esta bien)
/** Sube un archivo de Salesforce.
 * @param {Object} data - Datos del archivo a subir.
 * @returns {Promise<*>} Respuesta del servidor. */
export async function UploadSalesForceService(data) {
  const token = await getToken();
  const tokenMicro = await getTokenMicro();
  const formData = new FormData();

  formData.append("file", data.file);

  const finalData = await convertFileToBase64(formData, CODES.SALESFORCE, data);

  return axios({
    method: "POST",
    url: "masters/uploads/salesforce",
    data: finalData,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

//TODO: ajustar el objeto data con los nuevos atributos donde se haga el llamado a GetSalesForceList, el axios ya esta ajustado
/** Obtiene el listado de archivos de Salesforce cargados de una compañía.
 * @param {Object} data - Datos de la compañía.
 * @returns {Promise<*>} Listado de archivos. */
export async function GetSalesForceList(data) {
  const token = await getToken();
  const tokenMicro = await getTokenMicro();

  return axios({
    method: "POST",
    data: data,
    url: `masters/uploads/companies`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

/**
 * Función que permite obtener el listado de archivos cargados de una compañia
 * @param {data} Objeto que contiene los parametros a buscar
 * @returns Listado de archivos cargados
 */
export async function ApplyFiltersSalesForce(data) {
  const token = await getToken();
  const tokenMicro = await getTokenMicro();

  return axios({
    method: "POST",
    url: "masters/uploads",
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

/** Obtiene el listado de estados de archivos.
 * @returns {Promise<*>} Listado de estados. */
export async function GetFileStatusList() {
  const token = await getToken();
  return axios({
    method: "GET",
    url: `/status`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene la plantilla de descarga de Salesforce.
 * @returns {Promise<*>} Plantilla codificada. */
export async function GetSalesForceTemplate() {
  const token = await getToken();
  return axios({
    method: "GET",
    url: `salesforce/downloads/templates`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene la guía de Salesforce.
 * @returns {Promise<*>} Guía codificada. */
export async function GetSalesForceGuide() {
  const token = await getToken();
  return axios({
    method: "GET",
    url: `salesforce/downloads/guides`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Descarga un archivo de Salesforce.
 * @param {Object} data - Datos del archivo a descargar.
 * @returns {Promise<*>} Archivo descargado. */
export async function DownloadSalesForceFile(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `masters/downloads`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,

    headers: {
      Authorization: token,
    },
  });
}

/** Descarga el log de errores de Salesforce.
 * @param {Object} data - Datos del log a descargar.
 * @returns {Promise<*>} Log de errores. */
export async function DownloadSalesForceErrorLog(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `masters/downloads/logs`,
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,

    headers: {
      Authorization: token,
    },
  });
}

/** Descarga un archivo de Salesforce mediante el servicio de descarga.
 * @param {Object} data - Datos de descarga.
 * @returns {Promise<*>} Archivo descargado. */
export async function DownloadSalesForceService(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: "salesforce",
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene la vista previa de un archivo de Salesforce.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Vista previa del archivo. */
export async function GetPreviewSalesForce(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `salesforce/previews`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    data: data,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene el listado de comercios de Salesforce.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de comercios. */
export async function GetTradersList(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `salesforce/traders`,
    baseURL: env.REACT_APP_API_URL,
    data: data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene el listado de archivos descargados de Salesforce.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de archivos descargados. */
export async function GetSalesForcesDownloadedFiles(data) {
  const token = await getToken();
  const tokenMicro = await getTokenMicro();
  return axios({
    method: "POST",
    data,
    url: `masters/downloads/companies`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

/** Descarga los archivos descargados de Salesforce.
 * @param {Object} data - Datos de descarga.
 * @returns {Promise<*>} Archivos descargados. */
export async function DownloadSalesForcesDownloadedFiles(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `masters/downloads`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}
